import { createEnum } from "../../../utils/utils";

export const TestBlockchains = createEnum({
  ROPSTEN: "ROPSTEN",
  MUMBAI: "MUMBAI",
});

export const ProductionBlockchains = createEnum({
  BTC: "BTC",
  ETH: "ETH",
  BCH: "BCH",
  DOT: "DOT",
  BNB: "BNB",
  LTC: "LTC",
  ETC: "ETC",
  XRP: "XRP",
  BSV: "BSV",
  MATIC: "MATIC",
  HEDERA: "HEDERA",
  DOGE: "DOGE",
  ALGO: "ALGO",
  DASH: "DASH",
  ZEC: "ZEC",
  TRX: "TRX",
  EOS: "EOS",
  SOL: "SOL",
  ADA: "ADA",
  BSC: "BSC",
});

export type AllowedBlockchains =
  | typeof TestBlockchains.T
  | typeof ProductionBlockchains.T;

export const validationMap: Partial<
  Record<AllowedBlockchains, AllowedBlockchains>
> = {
  ROPSTEN: "ETH",
  MUMBAI: "MATIC",
  HEDERA: "HBAR" as AllowedBlockchains,
};
